import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { fromTenantInput, fmtTenant } from './tenantTime';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FIELDS = [['actual_block_out', 'Block-out'], ['actual_takeoff', 'Despegue'], ['actual_landing', 'Aterrizaje'], ['actual_block_in', 'Block-in']];

// Bloque C: el piloto reporta los tiempos de sus propios vuelos (el block-out se refleja en el turnaround)
export function FlightTimesDialog({ flight, tz, onClose }) {
    const [times, setTimes] = useState({});
    const [vals, setVals] = useState({});
    useEffect(() => {
        if (!flight) return;
        setVals({});
        axios.get(`${API}/flights/${flight.id}/times`).then(r => setTimes(r.data || {})).catch(() => setTimes({}));
    }, [flight]);
    const save = async (field) => {
        try {
            await axios.patch(`${API}/flights/${flight.id}/times`, { time_field: field, time_value: fromTenantInput(vals[field], tz) });
            toast.success('Tiempo registrado');
            const r = await axios.get(`${API}/flights/${flight.id}/times`);
            setTimes(r.data || {});
        } catch (e) { const d = e.response?.data?.detail; toast.error(typeof d === 'string' ? d : d?.message || 'Error'); }
    };
    return (
        <Dialog open={!!flight} onOpenChange={(o) => !o && onClose()}>
            <DialogContent data-testid="flight-times-dialog">
                <DialogHeader>
                    <DialogTitle>Tiempos · {flight?.flight_number}</DialogTitle>
                    <DialogDescription>Registra en orden: block-out, despegue, aterrizaje y block-in. Hora en zona {tz}.</DialogDescription>
                </DialogHeader>
                <div className="space-y-3">
                    {FIELDS.map(([k, label]) => (
                        <div key={k} className="flex items-end gap-2">
                            <div className="flex-1 space-y-1">
                                <Label className="text-xs">{label}{times[k] ? ` · registrado ${fmtTenant(times[k], tz).slice(11)}` : ''}</Label>
                                <Input type="datetime-local" value={vals[k] || ''} onChange={e => setVals({ ...vals, [k]: e.target.value })} data-testid={`times-${k}`} />
                            </div>
                            <Button size="sm" disabled={!vals[k]} onClick={() => save(k)} data-testid={`times-save-${k}`}>Guardar</Button>
                        </div>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
